<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'pending-invoice-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - Pending Invoices",
        selectedIndex: GetIndexByTabName("Pending Invoices"),
        tabs: SalesOrderTabs,
        exportFileName: "Pending Invoices List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PendingInvoiceList",
              filter: [],
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Invoices, Credits",
                message: "Get Started, Add a Sales Order to Despatch",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
          },
          columns: [
            {
              screenField: "Invoice",
              sortOrder: "desc",
              sortIndex: 0,
              minWidth: 120,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              filterIndex: 0,
              type: "Integer",
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              filterDataField: "SalesOrder",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 1,
            },
            {
              screenField: "DateIn",
              gridLabel: "Invoice Date",
              filterLabel: "Invoice Date",
              filterIndex: 6,
            },
            {
              screenField: "Customer",
              filterIndex: 3
            },
            {
              screenField: "BillToCustomer",
              visible: false,
              // filterIndex: 1,
              showInColumnChooser: false,
            },
            {
              screenField: "Branch",
              filterIndex: 5,
              visible: false,
            },
            {
              screenField: "CustPO",
              type: "Text",
              filterIndex: 2,
            },
            {
              screenField: "OrderRep",
              // visible: false,
              gridDataField: "SalesRepresentativeFullName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesRepresentativeFullName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesRepresentativeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesRepresentativeCode",
                  label: "Order Rep Code",
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: "Order Rep Full Name",
                  allowSearch: false,
                },
              ],
              filterDataField: "SalesRepresentativeCode",
              filterIndex: 8,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "SalesOrder",
            },
            {
              screenField: "DeliverTo",
              cellTemplate: undefined,
              itemTemplate: undefined,
              // cellTemplateRecord: undefined,
              gridDataField: "DeliveryAddressCompanyName",
              filterDataField: "DeliveryAddressCompanyName",
              filterIndex: 4,
              type: 'Text',
              exportFields: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  label: "Deliver To",
                },
              ],
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "CompanyName",
                  },
                ],
              },
              dataSourceConfig: {
                endpoint: "api/CustomerDeliveryAddress",
                sort: {
                  selector: "LineNo",
                  asc: true,
                },
                filter: [["Inactive", "=", "N"]],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "CompanyName",
                  },
                ],
              },
              valueExpr: "CompanyName",
              displayExpr: "CompanyName",
            },
            {
              screenField: "CurrencyCode",
              minWidth: 150,
            },
            {
              screenField: "ExchangeRate",
              minWidth: 150,
            },

            {
              screenField: "Total",
              gridLabel: "Total (FX)",
            },
            {
              screenField: "CustomerRep",
              visible: false,
              filterIndex: 7,
              showInColumnChooser: false,
            },
            {
              screenField: "InvoiceStatus",
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "Invoice",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.PrintPreview.forEach((element) => {
                    if (
                      (x.data.DeliveryNote == 0 &&
                        element.ScreenLayoutApplicationFeatureCode ===
                          "ReportDeliveryNote") ||
                      (x.data.InvoiceStatus == "Pending" &&
                        element.ScreenLayoutApplicationFeatureCode ===
                          "ReportInvoice")
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      ScreenLayoutApplicationFeatureCode:
                        element.ScreenLayoutApplicationFeatureCode,
                      Parameters: element.Parameters,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "Invoice",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.BackgroundPrint.forEach((element) => {
                    if (
                      (x.data.DeliveryNote == 0 &&
                        element.ReportDisplayName === "Delivery Note") ||
                      (x.data.InvoiceStatus == "Pending" &&
                        element.ReportDisplayName === "Invoice")
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      TransactionCode: element.TransactionCode,
                      ScreenName: element.ScreenName,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Credit",
                      data: data,
                      clickAction: this.goToCredit,
                      disabled: data.data.InvoiceType == "Credit" || !FeatureStorage.checkPermission("Invoice", "create"),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                // if (data.data.InvoiceType != "Credit") return false;
                // else return true;
                if (data) return true;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.dataField != "InvoiceStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        if (e.data.InvoiceType == "Invoice") {
          // this.onRowClicked(e, {
          //   view: this,
          //   page: "invoice",
          //   mode: "review",
          //   idProperty: "Invoice",
          // });

          this.onRowClicked(e, {
            view: this,
            page: "invoice-activation",
            mode: FeatureStorage.checkPermission("Invoice", "edit")
              ? "edit"
              : "review",
            idProperty: "Invoice",
          });
        } else {
          this.onRowClicked(e, {
            view: this,
            page: "credit-invoice",
            mode: "review",
            idProperty: "Invoice",
          });
        }
      }
    },
    goToCredit(e) {
      this.$router.push({
        path: `credit-invoice/create/${e.Invoice}`,
      });
    },
    // printOrder(e, grid) {
    //   DespatchOrderListService.printOrder({
    //     Code: e.Code,
    //   })
    //     // eslint-disable-next-line no-unused-vars
    //     .then((result) => {
    //       this.showLoading(false);
    //       // this.$logger.debug("result ", result);
    //       grid.refresh();
    //     })
    //     .catch((error) => {
    //       this.displayServerError(error, "Order Print Failed");
    //     });
    // },
    // lockOrder(e, grid) {
    //   DespatchOrderListService.lockOrder({
    //     Code: e.Code,
    //   })
    //     // eslint-disable-next-line no-unused-vars
    //     .then((result) => {
    //       this.showLoading(false);
    //       // this.$logger.debug("result ", result);
    //       grid.refresh();
    //     })
    //     .catch((error) => {
    //       this.displayServerError(error, "Order lock Failed");
    //     });
    // },
    // unLockOrder(e, grid) {
    //   DespatchOrderListService.unlockOrder({
    //     Code: e.Code,
    //   })
    //     // eslint-disable-next-line no-unused-vars
    //     .then((result) => {
    //       this.showLoading(false);
    //       // this.$logger.debug("result ", result);
    //       grid.refresh();
    //     })
    //     .catch((error) => {
    //       this.displayServerError(error, "Order unlock Failed");
    //     });
    // },
  },

  created() {},
};
</script>

<style lang="scss"></style>
